import {getOfferTemplate} from "@project/sdk/sales";
import {GetOfferTemplateResponse} from "@project/sdk/sales/zod";
import {queryOptions} from "@tanstack/react-query";
import {assertOfferTemplatePreview} from "../../../offerTemplate-read";
import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {offerTemplateKeys} from "../../../offerTemplate-keys";

export function getOfferTemplateQueryOptions(id: string) {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: offerTemplateKeys.detail(id),
    queryFn: async ({signal}) => {
      const response = await getOfferTemplate(id, {signal});
      const parsed = GetOfferTemplateResponse.parse(response);
      assertOfferTemplatePreview(parsed, response);
      return parsed;
    },
  });
}
